export const PHONE_NUMBER = '+49-179-422-5960';
export const EMAIL = 'ofrigpaz@gmail.com';
export const ADDRESS = 'Herderstraße 8, 12163 Berlin';
export const MAIN_URL = 'https://ohsofreeblog.com';
